import React from 'react';
import { Shield } from 'lucide-react';

const VisaLogo = () => (
  <svg viewBox="0 0 780 500" className="h-8 w-auto" style={{ minWidth: '80px' }}>
    <path d="M293.2 348.7l33.4-195.7h53.4l-33.4 195.7zM540.7 157.3c-10.5-4-27.1-8.3-47.7-8.3-52.6 0-89.7 26.5-89.9 64.5-.3 28.1 26.5 43.7 46.7 53.1 20.8 9.6 27.8 15.7 27.7 24.3-.1 13.1-16.6 19.1-32 19.1-21.4 0-32.7-3-50.3-10.2l-6.9-3.1-7.5 43.8c12.5 5.5 35.6 10.2 59.6 10.5 56 0 92.3-26.2 92.7-66.8.2-22.3-14-39.2-44.8-53.2-18.6-9.1-30.1-15.1-30-24.3 0-8.1 9.7-16.8 30.6-16.8 17.4-.3 30.1 3.5 39.9 7.5l4.8 2.3 7.1-42.4zM676.3 153h-41.2c-12.8 0-22.3 3.5-27.9 16.2l-79.2 179.5h56s9.2-24.1 11.2-29.4c6.1 0 60.5.1 68.3.1 1.6 6.9 6.5 29.3 6.5 29.3h49.5l-43.2-195.7zm-65.8 126.2c4.4-11.3 21.3-54.7 21.3-54.7-.3.5 4.4-11.3 7.1-18.7l3.6 16.9s10.2 46.8 12.4 56.5h-44.4zM232.1 153l-52.1 133.4-5.6-27.1c-9.7-31.2-39.8-65-73.5-81.9l47.7 170.2 56.4-.1 83.9-194.5h-56.8z" fill="#1A1F71"/>
    <path d="M124.7 153H36.4l-.7 4c66.9 16.2 111.2 55.3 129.6 102.3l-18.7-90.1c-3.2-12.4-12.8-15.8-21.9-16.2z" fill="#F7A600"/>
  </svg>
);

const MastercardLogo = () => (
  <svg viewBox="0 0 780 500" className="h-8 w-auto" style={{ minWidth: '60px' }}>
    <circle cx="330" cy="250" r="160" fill="#EB001B"/>
    <circle cx="450" cy="250" r="160" fill="#F79E1B"/>
    <path d="M390 130.7c-39.4 31.2-64.6 79.4-64.6 133.3s25.2 102.1 64.6 133.3c39.4-31.2 64.6-79.4 64.6-133.3s-25.2-102.1-64.6-133.3z" fill="#FF5F00"/>
  </svg>
);

const AmexLogo = () => (
  <svg viewBox="0 0 780 500" className="h-8 w-auto" style={{ minWidth: '80px' }}>
    <rect width="780" height="500" rx="40" fill="#016FD0"/>
    <g fill="white">
      {/* AMERICAN text */}
      <text x="390" y="210" textAnchor="middle" fontSize="88" fontWeight="800" fontFamily="'Helvetica Neue', Arial, sans-serif" letterSpacing="8">AMERICAN</text>
      {/* EXPRESS text */}
      <text x="390" y="320" textAnchor="middle" fontSize="88" fontWeight="800" fontFamily="'Helvetica Neue', Arial, sans-serif" letterSpacing="8">EXPRESS</text>
    </g>
  </svg>
);

const DiscoverLogo = () => (
  <svg viewBox="0 0 780 500" className="h-8 w-auto" style={{ minWidth: '90px' }}>
    <rect width="780" height="500" rx="40" fill="#fff" stroke="#E5E7EB" strokeWidth="3"/>
    <text x="100" y="290" fill="#231F20" fontSize="130" fontWeight="900" fontFamily="Arial Black, Arial, sans-serif" letterSpacing="-2">DISCOVER</text>
    <circle cx="520" cy="250" r="90" fill="#F76F20"/>
  </svg>
);

const ComplianceSection = () => {
  const logos = [
    { name: 'Visa', component: <VisaLogo /> },
    { name: 'Mastercard', component: <MastercardLogo /> },
    { name: 'American Express', component: <AmexLogo /> },
    { name: 'Discover', component: <DiscoverLogo /> }
  ];

  return (
    <section className="py-16 relative overflow-hidden" style={{ backgroundColor: '#132A4A' }}>
      {/* Professional gold/yellow swirl decoration */}
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none"
        viewBox="0 0 1200 400"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M-100,200 C100,80 300,350 500,180 C700,10 900,300 1100,120 C1200,60 1300,200 1400,150" fill="none" stroke="rgba(212,175,55,0.12)" strokeWidth="120" strokeLinecap="round"/>
        <path d="M-50,300 C150,180 350,380 550,250 C750,120 950,350 1150,200" fill="none" stroke="rgba(245,197,66,0.08)" strokeWidth="80" strokeLinecap="round"/>
        <path d="M0,100 C200,250 400,50 600,200 C800,350 1000,100 1200,250" fill="none" stroke="rgba(212,175,55,0.06)" strokeWidth="60" strokeLinecap="round"/>
      </svg>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-6" style={{ backgroundColor: 'rgba(34, 197, 94, 0.2)', color: '#22C55E' }}>
          <Shield size={16} />
          <span>Security & Compliance</span>
        </div>
        
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Built for <span style={{ color: '#D4AF37' }}>Compliance</span>. Designed for <span style={{ color: '#22C55E' }}>Longevity</span>.
        </h2>
        
        <p className="text-xl text-gray-300 mb-8">
          PCI compliant and aligned with Visa, Mastercard, Amex, and Discover guidelines.
        </p>
        
        {/* Card Brand Logos */}
        <div className="flex flex-wrap justify-center gap-6">
          {logos.map((logo, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl px-6 py-4 flex items-center justify-center shadow-lg"
              style={{ minWidth: '130px', minHeight: '70px' }}
              data-testid={`card-logo-${logo.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {logo.component}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComplianceSection;
